import type { DriverDisplayInfo } from "@/reducers/accountChatsSelectors"
import type { RouteStop } from "@/reducers/routes2gSlice"

const truckLabel = (driver: DriverDisplayInfo) =>
  driver.plates || driver.carLabel || driver.name

const stopPlace = (stop: RouteStop | undefined) =>
  stop?.location.locality || stop?.location.companyName || undefined

export type FleetQuestionContext = {
  carCount: number
  focusTruck?: string
  route?: { truck: string; place: string }
}

export const buildQuestionContext = (
  drivers: DriverDisplayInfo[],
): FleetQuestionContext => {
  const labelled = drivers.filter((driver) => truckLabel(driver))
  const [focus, ...rest] = [
    ...labelled.filter(({ isDriving }) => isDriving),
    ...labelled.filter(({ isDriving }) => !isDriving),
  ]
  const routeDriver = [focus, ...rest].find(
    (driver) => driver && stopPlace(driver.nextStop),
  )
  const place = stopPlace(routeDriver?.nextStop)
  return {
    carCount: drivers.length,
    focusTruck: focus && truckLabel(focus),
    route:
      routeDriver && place
        ? { truck: truckLabel(routeDriver), place }
        : undefined,
  }
}

export const FLEET_QUESTIONS: readonly {
  id: string
  topic: string
  text: (context: FleetQuestionContext) => string | undefined
}[] = [
  {
    id: "fleetStatus",
    topic: "Status floty i trasy",
    text: ({ carCount }) =>
      carCount > 0 ? "Jaki jest status floty?" : undefined,
  },
  {
    id: "driveTime",
    topic: "Czas jazdy i odpoczynki",
    text: ({ focusTruck }) =>
      focusTruck && `Ile jazdy zostało kierowcy ${focusTruck}?`,
  },
  {
    id: "routeEta",
    topic: "Trasa, dystans i opłaty",
    text: ({ route }) =>
      route &&
      `Ile auto ${route.truck} ma do celu (${route.place}) i czy zdąży?`,
  },
  {
    id: "driverMessage",
    topic: "Wiadomości do kierowców",
    text: ({ focusTruck }) => focusTruck && `Napisz do kierowcy ${focusTruck}`,
  },
  {
    id: "position",
    topic: "Pozycja aut i naczep",
    text: ({ focusTruck }) => focusTruck && `Gdzie jest auto ${focusTruck}?`,
  },
]
